import request from '@/router/axios';

///group-fengkong-audit-detail/{id}
export const groupFengkongAuditDetail = (id) => {
  return request({
    url: '/api/blade-loan-information/loan-audit-detail/group-fengkong-audit-detail',
    method: 'get',
    params: {
      id
    }
  })
}
